import { GridColDef, GridValueGetter } from "@mui/x-data-grid-pro";
import { PlayerRotationMinutes } from "../types";

const formatMinutes = (value: number): string =>
  value === 0 ? "-" : `${value}:00`;

export const baseColumns: GridColDef<PlayerRotationMinutes>[] = [
  {
    field: "playerName",
    headerName: "Player",
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    field: "q1Minutes",
    headerName: "Q1",
    width: 56,
    type: "number",
    valueFormatter: formatMinutes,
    disableColumnMenu: true,
  },
  {
    field: "q2Minutes",
    headerName: "Q2",
    width: 56,
    type: "number",
    valueFormatter: formatMinutes,
    disableColumnMenu: true,
  },
  {
    field: "q3Minutes",
    headerName: "Q3",
    width: 56,
    type: "number",
    valueFormatter: formatMinutes,
    disableColumnMenu: true,
  },
  {
    field: "q4Minutes",
    headerName: "Q4",
    width: 56,
    type: "number",
    valueFormatter: formatMinutes,
    disableColumnMenu: true,
  },
  {
    field: "totalMinutes",
    headerName: "Total",
    width: 56,
    type: "number",
    valueGetter: ((_value, row) =>
      row.q1Minutes +
      row.q2Minutes +
      row.q3Minutes +
      row.q4Minutes) as GridValueGetter<PlayerRotationMinutes, number>,
    valueFormatter: formatMinutes,
    disableColumnMenu: true,
  },
];
